// The lead card a website form lead puts at the top of its chat (Gary, 17 Oct). The server
// writes it as plain lines (supabase/functions/_shared/form-lead-chat.ts, cardText); the app
// reads the mobile and email back out of those lines for the Call, WhatsApp and Email buttons.

/** The card's own id in the chat: conversation_messages.provider_message_id. */
export const CARD_PREFIX = 'lead-card:';

export function isLeadCard(providerMessageId: string | null | undefined): boolean {
  return !!providerMessageId && providerMessageId.startsWith(CARD_PREFIX);
}

export interface CardContact {
  /** For tel: links, e.g. +27823232836. */
  phone: string | null;
  email: string | null;
}

const EMAIL = /^[^\s@<>"?&#:/]+@[^\s@<>"?&#:/]+\.[^\s@<>"?&#:/]+$/;

/** The mobile (or typed phone) and email on a card, only when they look right. */
export function cardContact(text: string): CardContact {
  let phone: string | null = null;
  let email: string | null = null;
  for (const line of text.split('\n')) {
    // The customer's message is last and may run over several lines: never read from it.
    if (line.startsWith('Message: ')) break;
    const m = /^(Mobile|Phone|Email): (.+)$/.exec(line.trim());
    if (!m) continue;
    const value = (m[2] ?? '').trim();
    if (m[1] === 'Email') {
      if (EMAIL.test(value)) email = value;
    } else if (!phone) {
      const digits = value.replace(/[^\d+]/g, '');
      if (/^\+?\d{9,15}$/.test(digits)) phone = digits;
    }
  }
  return { phone, email };
}
